class FileInfo
{
  id: number;
  parent_id: number;
  name: string;
  path: string;
  size: number;
  type: string;
  sha1_hash: string;
  timestamp_ctime: string;
  timestamp_mtime: string;
  experiment_id: number;

  constructor() {
    this.id = 0;
    this.parent_id = 0;
    this.name = '';
    this.path = '';
    this.size = 0;
    this.type = '';
    this.sha1_hash = '';
    this.timestamp_ctime = '';
    this.timestamp_mtime = '';
    this.experiment_id = 0;
  }

  load(data: any) {
    this.id = data.id;
    this.parent_id = data.parent_id;
    this.name = data.name;
    this.path = data.path;
    this.size = data.size;
    this.type = data.type;
    this.sha1_hash = data.sha1_hash;
    this.timestamp_ctime = data.timestamp_ctime;
    this.timestamp_mtime = data.timestamp_mtime;
    this.experiment_id = data.experiment_id;
  }

  buildFormData(): FormData {
    const data = new FormData();

    data.append('id', this.id.toString());
    data.append('parent_id', this.parent_id.toString());
    data.append('name', this.name);
    data.append('path', this.path);
    data.append('size', this.size.toString());
    data.append('type', this.type);
    data.append('sha1_hash', this.sha1_hash);
    data.append('timestamp_ctime', this.timestamp_ctime);
    data.append('timestamp_mtime', this.timestamp_mtime);
    data.append('experiment_id', this.experiment_id.toString());

    return data;
  }
}

export default FileInfo;
